import { render } from "./LoadElementsModal.vue?vue&type=template&id=c9a33bf8"
import script from "./LoadElementsModal.vue?vue&type=script&lang=ts"
export * from "./LoadElementsModal.vue?vue&type=script&lang=ts"

import "./LoadElementsModal.vue?vue&type=style&index=0&id=c9a33bf8&lang=scss"
script.render = render

export default script